module.exports = __webpack_public_path__ + "img/高尔夫之旅海报.5b385e00.jpg";